import { toAbsoluteUrl } from "../../_metronic/helpers";

export type TLanguage = "fr" | "en";

export const allLanguage = [
    {
        lang: "en",
        name: "english",
        flag: toAbsoluteUrl("/media/flags/uk.svg"),
    },
    {
        lang: "fr",
        name: "french",
        flag: toAbsoluteUrl("/media/flags/fr.svg"),
    },
];
